import React, { useEffect, useState } from "react";
import {
    Box, Typography, Button, TextField, Table, TableRow, TableContainer, TableHead, TableCell, TableBody, Paper, Chip, TablePagination, Modal, FormControl, RadioGroup,
    FormControlLabel, Radio, TextareaAutosize, Divider, Card, Select, MenuItem
} from "@mui/material";
import Header from "../components/header.tsx";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import nonuserimage from '../assets/nonuserimage.png';
import { ReactComponent as BoxesIcon } from '../assets/svg/boxes.svg';
import { ReactComponent as EditIco } from '../assets/svg/edit.svg';
import { ReactComponent as AddressBookIco } from '../assets/svg/addressbook.svg';
import { ReactComponent as SettingIco } from '../assets/svg/setting.svg';
import { ReactComponent as HelpIco } from '../assets/svg/help.svg';
import { ReactComponent as PrivacyIco } from '../assets/svg/file.svg';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import { Switch } from '@mui/material';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import PasswordIcon from '@mui/icons-material/Password';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import EuroIcon from '@mui/icons-material/Euro';
import deals_1 from '../assets/deals_1.jpg';
import deals_2 from '../assets/deals_2.jpg';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { CheckBox } from "@mui/icons-material";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import '../css/App.css';
import { ReactComponent as Dropbox } from '../assets/svg/dropbox.svg';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import { ReactComponent as OrderPackage } from '../assets/svg/packed_cardboard.svg';
import { toggleDarkMode } from '../features/themeSlice.ts';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

type Order = {
    id: number;
    orderId: string;
    invoiceNo: string;
    itemsCount: number;
    itemsName: string;
    address: string;
    delivery: string;
    orderStatus: string;
    paymentStatus: string;
    total: number | string;
    orderedDate: string;
};

const returnStatus = [
    {
        label: 'Return Requested',
        date: '22 June 2025',
        description: 'Return request submitted',
        completed: true,
    },
    {
        label: 'Return Approved',
        date: '23 June 2025',
        description: 'Your return request has been approved',
        completed: true,
    },
    {
        label: 'Return Package Received',
        date: '26 June 2025',
        description: 'We have received your return package',
        completed: true,
    },
    {
        label: 'Refund Processed',
        date: '28 June 2025',
        description: 'Refund of AED69.98 has been processed to your original payment method',
        completed: true,
    },
    {
        label: 'Refund Complete',
        date: '30 June 2025',
        description: '',
        completed: false,
    },
];

const orderStatus = [
    {
        label: 'Ordered',
        date: '15 June 2025',
        icon: <ShoppingCartIcon />,
        // description: 'Return request submitted',
        completed: true,
    },
    {
        label: 'Order Ready',
        date: '17 June 2025',
        icon: <Dropbox />,
        // description: 'Your return request has been approved',
        completed: true,
    },
    {
        label: 'Shipped',
        date: '19 June 2025',
        icon: <LocalShippingIcon />,
        // description: 'We have received your return package',
        completed: true,
    },
    {
        label: 'Out for delivery',
        date: '20 June 2025',
        icon: <TimelapseIcon />,
        // description: 'Refund of AED69.98 has been processed to your original payment method',
        completed: true,
    },
    {
        label: 'Delivered',
        date: '22 June 2025',
        icon: <OrderPackage />,
        // description: '',
        completed: false,
    },
];

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 3,
};


const UserProfile = () => {

    const dispatch = useDispatch();
    const darkMode = useSelector((state: any) => state.theme.darkMode);

    const navigate = useNavigate();
    const [selectedMenu, setSelectedMenu] = useState(() => sessionStorage.getItem('user_profile_menu') || 'edit');
    const [selectedTab, setSelectedTab] = useState<'current' | 'past' | 'return'>(() => {
        const saved = localStorage.getItem('user_profile_order_tab');
        return saved === 'past' || saved === 'return' || saved === 'current' ? saved : 'current';
    });
    const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [openReturnModal, setOpenReturnModal] = useState(false);
    const [openRefundStatusModal, setOpenRefundStatusModal] = useState(false);
    const [isAddingAddress, setIsAddingAddress] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    const [selectedCurrency, setSelectedCurrency] = useState('USD');
    const [changingnewpassword, setChangingNewPassword] = useState(false);

    // Persist the active Resolution/My Orders tab so a page refresh does not reset it.
    useEffect(() => {
        localStorage.setItem('user_profile_order_tab', selectedTab);
    }, [selectedTab]);

    useEffect(() => {
        sessionStorage.setItem('user_profile_menu', selectedMenu);
    }, [selectedMenu]);

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '40%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 2,
        maxHeight: '90vh',
        overflowY: 'auto'
    };

    /* for pagination */
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;

    const allOrders = [
        {
            id: 1,
            type: 'current',
            orderId: 'ORD001',
            invoiceNo: 'INV001',
            itemsCount: 3,
            itemsName: 'T-shirt, Shoes, Watch',
            address: '123 Street, City',
            delivery: '25 July 2025',
            orderStatus: 'Shipped',
            paymentStatus: 'Paid',
            total: 'AED120',
            orderedDate: '20 July 2025',
        },
        {
            id: 2,
            type: 'past',
            orderId: 'ORD002',
            invoiceNo: 'INV002',
            itemsCount: 1,
            itemsName: 'Backpack',
            address: '456 Avenue, City',
            delivery: '15 June 2025',
            orderStatus: 'Delivered',
            paymentStatus: 'Paid',
            total: 'AED45',
            orderedDate: '10 June 2025',
        },
        {
            id: 3,
            type: 'current',
            orderId: 'ORD003',
            invoiceNo: 'INV003',
            itemsCount: 1,
            itemsName: 'watch',
            address: '456 Avenue, City',
            delivery: '17 June 2025',
            orderStatus: 'Delivered',
            paymentStatus: 'Paid',
            total: 'AED49',
            orderedDate: '11 June 2025',
        },
        {
            id: 4,
            type: 'current',
            orderId: 'ORD004',
            invoiceNo: 'INV004',
            itemsCount: 1,
            itemsName: 'AirPods',
            address: '456 Avenue, City',
            delivery: '18 June 2025',
            orderStatus: 'Delivered',
            paymentStatus: 'Paid',
            total: 'AED55',
            orderedDate: '12 June 2025',
        },
        {
            id: 5,
            type: 'return',
            orderId: 'ORD005',
            invoiceNo: 'INV005',
            itemsCount: 1,
            itemsName: 'bluetooth speaker',
            address: 'Berlin, City',
            delivery: '20 June 2025',
            orderStatus: 'Delivered',
            paymentStatus: 'Paid',
            total: 'AED55',
            orderedDate: '12 June 2025',
            return_requested: '22 June 2025',
            reason: 'Item arrived damaged',
            return_status: 'Return Approved'
        },
        {
            id: 6,
            type: 'return',
            orderId: 'ORD006',
            invoiceNo: 'INV006',
            itemsCount: 1,
            itemsName: 'Smart Watch',
            address: '432 Berlin, City',
            delivery: '21 June 2025',
            orderStatus: 'Delivered',
            paymentStatus: 'Paid',
            total: 'AED55',
            orderedDate: '12 June 2025',
            return_requested: '23 June 2025',
            reason: 'Item arrived damaged',
            return_status: 'Return Requested'
        },
    ];

    const filteredOrders = allOrders.filter(order => order.type === selectedTab);
    const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
    const paginatedOrders = filteredOrders.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    /* end pagination */

    const handleViewInvoice = (order: any) => {
        setSelectedOrder(order);
        setOpenInvoiceModal(true);
    };

    const handleCancelOrder = (order: any) => {
        setSelectedOrder(order);
        setOpenCancelModal(true);
    };

    const handleReturnProduct = (order: any) => {
        setSelectedOrder(order);
        setOpenReturnModal(true);
    }

    return (
        <>
            {/* Header */}
            <Header />
            {/* end header */}

            <Box sx={{ padding: '3%' }}>
                {/* profile header */}
                <Box className="profile-header">
                    <Typography sx={{ color: darkMode ? '#fff' : '#000', fontSize: '22px', fontWeight: 'bold' }}>My Account</Typography>
                    <Box sx={{ display: 'flex', gap: '1px', alignItems: 'center' }}>
                        <HomeOutlinedIcon sx={{ color: darkMode ? '#fff' : '#000' }} />
                        <KeyboardDoubleArrowRightOutlinedIcon sx={{ color: darkMode ? '#fff' : '#000' }} />
                        <Typography sx={{ color: darkMode ? '#fff' : '#000', fontSize: '12px', fontWeight: 'lighter' }}>My Account</Typography>
                    </Box>
                </Box>
                {/* end profile header */}

                {/* body card */}
                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                    {/* Left Card */}
                    <Box className="profile-menu-card"
                        sx={{
                            flex: 0.5,
                            padding: 2,
                            boxShadow: 2,
                            background: darkMode ? '#000' : '#fff'
                        }}
                    >
                        {/* Profile Image */}
                        <Box
                            component="img"
                            src={nonuserimage}
                            alt="Profile"
                            sx={{
                                width: 100,
                                height: 100,
                                borderRadius: '50%',
                                objectFit: 'cover',
                            }}
                        />
                        <Typography>Hello</Typography>
                        <Typography sx={{ mb: 3 }}>xxx</Typography>

                        {/* Profile Menu */}
                        <Box className="profile-menu" sx={{ gap: 2 }}>
                            {[
                                { label: 'My Orders', icon: <BoxesIcon />, value: 'orders' },
                                { label: 'Edit Profile', icon: <EditIco />, value: 'edit' },
                                { label: 'Change Password', icon: <PasswordIcon />, value: 'changepassword' },
                                { label: 'Address Book', icon: <AddressBookIco />, value: 'address' },
                                { label: 'Settings', icon: <SettingIco />, value: 'settings' },
                                { label: 'Help Center', icon: <HelpIco />, value: 'help' },
                                { label: 'Privacy Policy', icon: <PrivacyIco />, value: 'policy' },
                            ].map((item, index) => (
                                <Typography
                                    key={index}
                                    onClick={() => setSelectedMenu(item.value)}
                                    sx={{
                                        fontSize: '14px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        gap: 1,
                                        alignItems: 'center',
                                        padding: '6px 10px',
                                        borderRadius: '6px',
                                        transition: 'background 0.3s',
                                        '&:hover': {
                                            backgroundColor: darkMode ? 'gray' : '#f0f0f0',
                                        },
                                        background: selectedMenu === item.value ? '#f0f0f0' : ''
                                    }}
                                >
                                    {item.icon} {item.label}
                                </Typography>
                            ))}
                        </Box>
                        <Button fullWidth variant="contained" sx={{ textTransform: "none", fontWeight: "bold", backgroundColor: "#C32032", mt: 1, fontSize: '14px', cursor: 'pointer' }}>
                            Log out
                        </Button>
                    </Box>

                    {/* Right Card */}
                    <Box
                        sx={{
                            flex: 2,
                            background: '#fff',
                            borderRadius: '10px',
                            padding: 2,
                            boxShadow: 2,
                        }}
                    >
                        {selectedMenu === 'edit' ? (
                            <>
                                <Typography variant="h6" fontWeight="bold" mb={2}>Edit Profile</Typography>

                                {/* Profile Image Upload */}
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                                    <Box
                                        component="img"
                                        src={nonuserimage}
                                        alt="Profile"
                                        sx={{
                                            width: 100,
                                            height: 100,
                                            borderRadius: '50%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                    <Button variant="outlined" component="label">
                                        Change Image
                                        <input hidden accept="image/*" type="file" />
                                    </Button>
                                </Box>

                                {/* Editable Fields */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <TextField label="First Name" InputLabelProps={{ shrink: true }} fullWidth value={'Jhon Doe'}/>
                                    <TextField label="Last Name" InputLabelProps={{ shrink: true }} fullWidth />
                                    <TextField label="Email" InputLabelProps={{ shrink: true }} fullWidth value={'tewak88667@binafex.com'}/>
                                    <TextField label="Phone Number" InputLabelProps={{ shrink: true }} fullWidth value={'+971 123 456 7890'}/>
                                    <TextField
                                        label="Date of Birth"
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    <Button variant="contained" sx={{ backgroundColor: '#C32032', fontWeight: 'bold', textTransform: 'none' }}>
                                        Save Changes
                                    </Button>
                                </Box>
                            </>
                        ) : selectedMenu === 'settings' ? (
                            <>
                                <Typography variant="h6" fontWeight="bold" mb={2}>Settings</Typography>

                                {/* Notifications Card */}
                                <Box sx={{ backgroundColor: '#f9f9f9', borderRadius: 2, p: 2, mb: 2 }}>
                                    <Typography fontWeight="bold" fontSize="14px" mb={1}>Notifications</Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <NotificationsNoneIcon sx={{ color: '#C32032' }} />
                                            <Typography>Push Notifications</Typography>
                                        </Box>
                                        <Switch defaultChecked />
                                    </Box>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <EmailOutlinedIcon sx={{ color: '#C32032' }} />
                                            <Typography>Marketing Emails</Typography>
                                        </Box>
                                        <Switch />
                                    </Box>
                                </Box>

                                {/* Appearance Card */}
                                <Box sx={{ backgroundColor: '#f9f9f9', borderRadius: 2, p: 2, mb: 2 }}>
                                    <Typography fontWeight="bold" fontSize="14px" mb={1}>Appearance</Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <DarkModeOutlinedIcon sx={{ color: '#C32032' }} />
                                            <Typography>Dark Mode</Typography>
                                        </Box>
                                        <Switch checked={darkMode} onChange={() => dispatch(toggleDarkMode())} />
                                    </Box>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <LanguageOutlinedIcon sx={{ color: '#C32032' }} />
                                            <Typography>Language</Typography>
                                        </Box>
                                        <FormControl size="small" sx={{ minWidth: 120 }}>
                                            <Select
                                                value={selectedLanguage}
                                                onChange={(e) => setSelectedLanguage(e.target.value)}
                                                displayEmpty
                                                sx={{
                                                    fontSize: '14px',
                                                    color: 'gray',
                                                    backgroundColor: 'white',
                                                    borderRadius: 1,
                                                }}
                                            >
                                                <MenuItem value="en">English</MenuItem>
                                                <MenuItem value="ar">Arabic</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Box>

                                {/* Shopping Card */}
                                <Box sx={{ backgroundColor: '#f9f9f9', borderRadius: 2, p: 2 }}>
                                    <Typography fontWeight="bold" fontSize="14px" mb={1}>Shopping</Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <ShoppingCartIcon sx={{ color: '#C32032' }} />
                                            <Typography>Auto-save Cart</Typography>
                                        </Box>
                                        <Switch />
                                    </Box>

                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <EuroIcon sx={{ color: '#C32032' }} />
                                            <Typography>Currency</Typography>
                                        </Box>
                                        <FormControl size="small" sx={{ minWidth: 120 }}>
                                            <Select
                                                value={selectedCurrency}
                                                onChange={(e) => setSelectedCurrency(e.target.value)}
                                                displayEmpty
                                                sx={{
                                                    fontSize: '14px',
                                                    color: 'gray',
                                                    backgroundColor: 'white',
                                                    borderRadius: 1,
                                                }}
                                            >
                                                <MenuItem value="USD">$ - USD (US Dollar)</MenuItem>
                                                <MenuItem value="AED">د.إ - AED (Emirati Dirham)</MenuItem>
                                                <MenuItem value="SAR">﷼ - SAR (Saudi Riyal)</MenuItem>
                                                <MenuItem value="QAR">ر.ق - QAR (Qatari Riyal)</MenuItem>
                                                <MenuItem value="KWD">د.ك - KWD (Kuwaiti Dinar)</MenuItem>
                                                <MenuItem value="OMR">ر.ع. - OMR (Omani Rial)</MenuItem>
                                                <MenuItem value="BHD">ب.د - BHD (Bahraini Dinar)</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Box>
                            </>
                        ) : selectedMenu === 'orders' ? (
                            <>
                                <Typography variant="h6" gutterBottom>My Orders</Typography>
                                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                                    <Chip
                                        label="Current Orders"
                                        color={selectedTab === 'current' ? 'primary' : 'default'}
                                        onClick={() => {
                                            setSelectedTab('current');
                                            setCurrentPage(1);
                                        }}
                                        variant={selectedTab === 'current' ? 'filled' : 'outlined'}
                                    />
                                    <Chip
                                        label="Past Orders"
                                        color={selectedTab === 'past' ? 'primary' : 'default'}
                                        onClick={() => {
                                            setSelectedTab('past');
                                            setCurrentPage(1);
                                        }}
                                        variant={selectedTab === 'past' ? 'filled' : 'outlined'}
                                    />
                                    <Chip
                                        label="Returns"
                                        color={selectedTab === 'return' ? 'primary' : 'default'}
                                        onClick={() => {
                                            setSelectedTab('return');
                                            setCurrentPage(1);
                                        }}
                                        variant={selectedTab === 'return' ? 'filled' : 'outlined'}
                                    />
                                </Box>

                                <TableContainer component={Paper}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                                {[
                                                    'S.No', 'Order ID', 'Invoice No', 'Items Count', 'Items Name',
                                                    'Address', (selectedTab === 'return' ? 'Estimated Delivery' : 'Delivered'), (selectedTab === 'return' ? 'Reason' : 'Order Status'),
                                                    (selectedTab === 'return' ? 'Return Status' : 'Payment Status'), 'Total', (selectedTab === 'return' ? 'Return Requested' : 'Ordered Date')
                                                ].map((head, idx) => (
                                                    <TableCell key={idx} sx={{ fontWeight: 'bold' }}>{head}</TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {paginatedOrders.map((order, index) => (
                                                <React.Fragment key={order.id}>
                                                    <TableRow key={order.id} sx={{
                                                        '& td': {
                                                            borderBottom: 'none',
                                                            paddingBottom: 1
                                                        },
                                                    }}>
                                                        <TableCell>{(currentPage - 1) * rowsPerPage + index + 1}</TableCell>
                                                        <TableCell>{order.orderId}</TableCell>
                                                        <TableCell>{order.invoiceNo}</TableCell>
                                                        <TableCell>{order.itemsCount}</TableCell>
                                                        <TableCell>{order.itemsName}</TableCell>
                                                        <TableCell>{order.address}</TableCell>
                                                        <TableCell>{order.delivery}</TableCell>
                                                        <TableCell>{selectedTab === 'return' ? order.reason : order.orderStatus}</TableCell>
                                                        <TableCell>{selectedTab === 'return' ? order.return_status : order.paymentStatus}</TableCell>
                                                        <TableCell>{order.total}</TableCell>
                                                        <TableCell>{selectedTab === 'return' ? order.return_requested : order.orderedDate}</TableCell>
                                                    </TableRow>

                                                    {selectedTab === 'current' && (<TableRow>
                                                        <TableCell colSpan={11}>
                                                            <Box display="flex" justifyContent="flex-end" gap={2}>
                                                                <Button variant="outlined" size="small" onClick={() => handleViewInvoice(order)} sx={{ textTransform: 'none' }}>View Invoice</Button>
                                                                <Button variant="contained" color="error" size="small" onClick={() => handleCancelOrder(order)} sx={{ textTransform: 'none' }}>Cancel Order</Button>
                                                                <Button variant="contained" color="error" size="small" onClick={() => navigate('/view-order')} sx={{ textTransform: 'none' }}>Track/View Order</Button>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>)}

                                                    {selectedTab === 'past' && (<TableRow>
                                                        <TableCell colSpan={11}>
                                                            <Box display="flex" justifyContent="flex-end" gap={2}>
                                                                <Button variant="contained" color="error" size="small" onClick={() => handleReturnProduct(order)} sx={{ textTransform: 'none' }}>Return Product</Button>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>)}

                                                    {selectedTab === 'return' && (<TableRow>
                                                        <TableCell colSpan={11}>
                                                            <Box display="flex" justifyContent="flex-end" gap={2}>
                                                                <Button variant="outlined" size="small" onClick={() => handleViewInvoice(order)} sx={{ textTransform: 'none' }}>View Invoice</Button>
                                                                <Button variant="contained" color="error" size="small" onClick={() => setOpenRefundStatusModal(true)} sx={{ textTransform: 'none' }}>Return & Refund Status</Button>
                                                            </Box>
                                                        </TableCell>
                                                    </TableRow>)}
                                                </React.Fragment>
                                            ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        count={filteredOrders.length}
                                        page={currentPage - 1}
                                        onPageChange={(_, newPage) => setCurrentPage(newPage + 1)}
                                        rowsPerPage={rowsPerPage}
                                        rowsPerPageOptions={[5]}
                                        onRowsPerPageChange={() => { }}
                                    />
                                </TableContainer>
                            </>
                        ) : selectedMenu === 'address' ? (
                            isAddingAddress ?
                                (<>
                                    <Typography variant="h6" fontWeight="bold" mb={2}>Add/Edit Address</Typography>

                                    {/* Editable Fields */}
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                        <TextField label="Address Name" fullWidth placeholder="e.g.Home, work etc.," />
                                        <TextField label="Street Address" fullWidth placeholder="street name, house number etc.," />
                                        <TextField label="City" fullWidth />
                                        <TextField label="Postal Code" fullWidth />
                                        <TextField label="Country" fullWidth />
                                        <TextField label="Phone Number" fullWidth />
                                        <Typography sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}><CheckBox />Set as default address</Typography>
                                        <Button variant="contained" sx={{ backgroundColor: '#C32032', fontWeight: 'bold', textTransform: 'none' }} onClick={() => setIsAddingAddress(false)}>
                                            Add Address
                                        </Button>
                                    </Box>
                                </>)
                                :
                                (<>
                                    <Box sx={{ display: 'flex', justifyContent: 'right', mb: 2 }}>
                                        <Button variant="contained" sx={{ backgroundColor: '#C32032', fontWeight: 'bold', textTransform: 'none' }} onClick={() => setIsAddingAddress(true)}>
                                            <AddIcon sx={{ mr: 0.5 }} />Add Address
                                        </Button>
                                    </Box>
                                    {[
                                        {
                                            id: 1,
                                            name: 'John Doe',
                                            address: 'Villa 25, Street 12B,\n Al Barsha 2 Near Al Barsha Mall Dubai,\nUnited Arab Emirates',
                                            phone: '+91 123 456 7890',
                                            tag: 'Home',
                                            isDefault: true
                                        },
                                        {
                                            id: 2,
                                            name: 'Jane Smith',
                                            address: '456 Avenue Road, Town, State - 654321',
                                            phone: '+91 9123456780',
                                            tag: 'Work',
                                            isDefault: false
                                        },
                                    ].map((addr) => (
                                        <Card key={addr.id} sx={{ mb: 2, p: 2, borderRadius: 2, boxShadow: 2 }}>
                                            <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={1}>
                                                <Typography variant="subtitle1" fontWeight={600} sx={{ alignItems: 'center', display: 'flex' }}>
                                                    <LocationOnIcon fontSize="small" sx={{ mr: 0.5 }} />
                                                    {addr.tag}{addr.isDefault && <Chip label="Default" size="small" sx={{ ml: 1, background: '#ffe5e5', color: '#d32f2f', width: '72px' }} />}
                                                </Typography>

                                                <Box display="flex" gap={1}>
                                                    <Button size="small" variant="outlined" color="primary" sx={{ textTransform: 'none' }} onClick={() => setIsAddingAddress(true)}>
                                                        <EditIcon fontSize="small" sx={{ mr: 0.5 }} />Edit
                                                    </Button>
                                                    <Button size="small" variant="outlined" color="error" sx={{ textTransform: 'none' }}>
                                                        <DeleteIcon fontSize="small" sx={{ mr: 0.5 }} />Remove
                                                    </Button>
                                                </Box>
                                            </Box>

                                            <Divider sx={{ mb: 1 }} />
                                            <Typography variant="body2" mb={0.5} sx={{ whiteSpace: 'pre-line' }}>{addr.address}</Typography>
                                            <Typography variant="body2">Phone: {addr.phone}</Typography>
                                        </Card>
                                    ))}
                                </>)
                        ) : selectedMenu === 'changepassword' ? (
                            <>
                                <Typography variant="h6" fontWeight="bold" mb={2}>Change Password</Typography>

                                {/* Editable Fields */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <TextField label="Old Password" type="password" fullWidth />
                                    <TextField label="New Password" type="password" fullWidth />
                                    <TextField label="Re-enter New Password" type="password" fullWidth />
                                    <Button variant="contained" sx={{ backgroundColor: '#C32032', fontWeight: 'bold', textTransform: 'none' }}>
                                        Save Changes
                                    </Button>
                                </Box>
                            </>
                        ) : (
                            <>
                                <Typography variant="h6" fontWeight="bold">Welcome to your profile</Typography>
                                <Typography variant="body2" sx={{ mt: 1 }}>
                                    Here you can manage your personal information and settings.
                                </Typography>
                            </>
                        )}
                    </Box>
                </Box>
                {/* end body card */}
            </Box>

            {/* Popups */}

            {/* Invoice Modal */}
            <Modal open={openInvoiceModal} onClose={() => setOpenInvoiceModal(false)}>
                <Box sx={style}>
                    <Typography variant="h6" gutterBottom>
                        Invoice Preview for Order #{selectedOrder?.orderId}
                    </Typography>
                    <Divider />
                    <Box mt={2} mb={3}>
                        <Typography><strong>Invoice No:</strong> {selectedOrder?.invoiceNo}</Typography>
                        <Typography><strong>Items:</strong> {selectedOrder?.itemsName}</Typography>
                        <Typography><strong>Amount:</strong> {selectedOrder?.total}</Typography>
                        <Typography><strong>Address:</strong> {selectedOrder?.address}</Typography>
                        <Typography><strong>Date:</strong> {selectedOrder?.orderedDate}</Typography>
                    </Box>
                    <Box display="flex" justifyContent="flex-end" gap={2}>
                        <Button onClick={() => setOpenInvoiceModal(false)} variant="outlined">Close</Button>
                        <Button /* onClick={handleDownload} */ variant="contained" color="primary">
                            Download Invoice
                        </Button>
                    </Box>
                </Box>
            </Modal>

            {/* Cancel Order Modal */}
            <Modal open={openCancelModal} onClose={() => setOpenCancelModal(false)}>
                <Box sx={style}>
                    <Typography variant="h6" gutterBottom>
                        Cancel Order
                    </Typography>
                    <Divider />
                    <Typography variant="h6" gutterBottom sx={{ borderBottom: '1px solid #CCBCBCB', mt: 1, display: 'flex', flexDirection: 'column', gap: '1px' }}>
                        {`#${selectedOrder?.orderId}`}
                        <span style={{ fontWeight: 'lighter', fontSize: '12px' }}>{`Ordered on ${selectedOrder?.orderedDate}`}</span>
                    </Typography>
                    <Divider />
                    <Box mt={2} mb={3}>
                        <Typography variant="h6" gutterBottom>
                            Reason for Cancellation
                        </Typography>

                        <FormControl component="fieldset">
                            <RadioGroup
                            /* value={selectedReason}
                            onChange={(e) => setSelectedReason(e.target.value)} */
                            >
                                <FormControlLabel
                                    value="Changed my mind"
                                    control={<Radio />}
                                    label="Changed my mind"
                                />
                                <FormControlLabel
                                    value="Found better price elsewhere"
                                    control={<Radio />}
                                    label="Found better price elsewhere"
                                />
                                <FormControlLabel
                                    value="Estimated delivery too slow"
                                    control={<Radio />}
                                    label="Estimated delivery too slow"
                                />
                                <FormControlLabel
                                    value="Ordered by mistake"
                                    control={<Radio />}
                                    label="Ordered by mistake"
                                />
                                <FormControlLabel
                                    value="Other reason"
                                    control={<Radio />}
                                    label="Other reason"
                                />
                            </RadioGroup>
                        </FormControl>

                        <Box mt={2}>
                            <Typography variant="subtitle1">Additional Information</Typography>
                            <TextareaAutosize
                                minRows={3}
                                placeholder="Provide more details about the cancellation..."
                                style={{ width: '100%', padding: '8px', borderRadius: 4, borderColor: '#ccc', fontFamily: 'inherit' }}
                            /* value={additionalInfo}
                            onChange={(e) => setAdditionalInfo(e.target.value)} */
                            />
                        </Box>


                        <Box mt={2} sx={{ display: 'flex', gap: '8px' }}>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={() => setOpenCancelModal(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                            /* onClick={handleCancelConfirm}
                            disabled={!selectedReason} */
                            >
                                Submit Cancellation
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Return product Modal */}
            <Modal open={openReturnModal} onClose={() => setOpenReturnModal(false)}>
                <Box sx={style}>
                    <Typography variant="h6" gutterBottom>
                        Return Items
                    </Typography>
                    <Divider />
                    <Typography variant="h6" gutterBottom sx={{ borderBottom: '1px solid #CCBCBCB', mt: 1, display: 'flex', flexDirection: 'column', gap: '1px' }}>
                        {`#${selectedOrder?.orderId}`}
                        <span style={{ fontWeight: 'lighter', fontSize: '12px' }}>{`Ordered on ${selectedOrder?.orderedDate}`}</span>
                    </Typography>
                    <Divider />

                    <Box mt={2}>
                        <Typography variant="h6" gutterBottom>
                            Select items to return
                        </Typography>

                        <Box display="flex" gap={1} mb={1}>
                            <Button size="small" variant="outlined">Select All</Button>
                            <Button size="small" variant="outlined">Clear</Button>
                        </Box>

                        {[
                            { id: 1, name: 'Bluetooth Speaker', price: 79.99, image: deals_1 },
                            { id: 2, name: 'Wireless Charger', price: 39.99, image: deals_2 }
                        ].map(item => (
                            <Box
                                key={item.id}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    border: '1px solid #eee',
                                    borderRadius: 2,
                                    p: 1,
                                    mb: 1
                                }}
                            >
                                <Radio sx={{ mr: 1 }} />
                                <Box display="flex" alignItems="center" gap={2}>
                                    <Box
                                        component="img"
                                        src={item.image}
                                        alt={item.name}
                                        sx={{ width: 40, height: 40, borderRadius: 1 }}
                                    />
                                    <Box>
                                        <Typography>{item.name}</Typography>
                                        <Typography fontSize={12} color="text.secondary">AED{item.price.toFixed(2)}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        ))}

                        <Box display="flex" justifyContent="space-between" mt={2} px={1}>
                            <Typography fontSize={14}>0 item(s) selected</Typography>
                            <Typography fontSize={14} color="error">Total: AED0.00</Typography>
                        </Box>
                    </Box>

                    <Box mt={2} mb={3}>
                        <Typography variant="h6" gutterBottom>
                            Reason for return
                        </Typography>

                        <FormControl component="fieldset">
                            <RadioGroup
                            /* value={selectedReason}
                            onChange={(e) => setSelectedReason(e.target.value)} */
                            >
                                <FormControlLabel
                                    value="Product is defective or damaged"
                                    control={<Radio />}
                                    label="Product is defective or damaged"
                                />
                                <FormControlLabel
                                    value="Wrong item delivered"
                                    control={<Radio />}
                                    label="Wrong item delivered"
                                />
                                <FormControlLabel
                                    value="Item is not as described"
                                    control={<Radio />}
                                    label="Item is not as described"
                                />
                                <FormControlLabel
                                    value="Changed my mind"
                                    control={<Radio />}
                                    label="Changed my mind"
                                />
                                <FormControlLabel
                                    value="Other reason"
                                    control={<Radio />}
                                    label="Other reason"
                                />
                            </RadioGroup>
                        </FormControl>

                        <Box mt={2}>
                            <Typography variant="subtitle1">Additional Information</Typography>
                            <TextareaAutosize
                                minRows={3}
                                placeholder="Provide more details about the return..."
                                style={{ width: '100%', padding: '8px', borderRadius: 4, borderColor: '#ccc', fontFamily: 'inherit' }}
                            /* value={additionalInfo}
                            onChange={(e) => setAdditionalInfo(e.target.value)} */
                            />
                        </Box>


                        <Box mt={2} sx={{ display: 'flex', gap: '8px' }}>
                            <Button
                                variant="outlined"
                                color="error"
                                onClick={() => setOpenReturnModal(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                            /* onClick={handleCancelConfirm}
                            disabled={!selectedReason} */
                            >
                                Submit Return Request
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Return & Refund Status Modal */}
            <Modal open={openRefundStatusModal} onClose={() => setOpenRefundStatusModal(false)}>
                <Box sx={modalStyle}>
                    <Typography variant="h6" gutterBottom>
                        Return & Refund Status
                    </Typography>
                    <Divider sx={{ mb: 2 }} />

                    {returnStatus.map((step, index) => (
                        <Box key={index} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', position: 'relative' }}>

                            {/* Icon + Vertical Line */}
                            <Box sx={{ position: 'relative', pr: 1 }}>
                                {/* The icon */}
                                <Box sx={{ zIndex: 1, position: 'relative' }}>
                                    {step.completed ? (
                                        <CheckCircleIcon sx={{ color: '#c62828' }} fontSize="small" />
                                    ) : (
                                        <RadioButtonUncheckedIcon sx={{ color: '#c62828' }} fontSize="small" />
                                    )}
                                </Box>

                                {/* Vertical line (for all but the last item) */}
                                {index < returnStatus.length - 2 && (
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: 20,
                                            left: '38%',
                                            transform: 'translateX(-50%)',
                                            width: '2px',
                                            height: '69px',
                                            backgroundColor: '#c62828',
                                            zIndex: 0,
                                        }}
                                    />
                                )}
                            </Box>

                            {/* Text section */}
                            <Box pb={index < returnStatus.length - 1 ? 3 : 0}>
                                <Typography fontWeight={600}>{step.label}</Typography>
                                <Typography variant="caption" display="block" gutterBottom>
                                    {step.date}
                                </Typography>
                                {step.description && (
                                    <Typography variant="body2" color="text.secondary">
                                        {step.description}
                                    </Typography>
                                )}
                            </Box>
                        </Box>
                    ))}

                    <Box mt={2} sx={{ display: 'flex', gap: '8px' }}>
                        <Button
                            variant="outlined"
                            color="error"
                            onClick={() => setOpenRefundStatusModal(false)}
                        >
                            Close
                        </Button>
                    </Box>
                </Box>
            </Modal>

            {/* end popups */}
        </>
    );
}

export default UserProfile;